import { PayloadAction } from '@reduxjs/toolkit'
import { ReduxAppState } from '../types'

export const setHomeSearchQuery = (
  state: ReduxAppState,
  action: PayloadAction<string | null>
) => {
  state.home.search.query = action.payload?.trim() ?? null
}
